import { Injectable } from "@angular/core";
import { API_PATH } from "../../../environments/config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SlotService } from "../slot/slot.service";

@Injectable({
  providedIn: "root",
})
export class QuotationsService {
  quotationDetails;
  currentDetailsIndex;
  totalQuotesCount;
  currentPageNumber;
  currentSearchText;
  totalQuotes;
  selectedTab;
  productQuoteCreation;
  isOrder;
  redirectOrder;
  constructor(private http: HttpClient, public slotService: SlotService) {}
  createQuotation(data) {
    return this.http.post<any>(API_PATH.quotationAPI.createQuotation, data);
  }
  createQuoteOrder(data) {
    return this.http.post<any>(API_PATH.quotationAPI.createQuoteOrder, data);
  }
  updateQuotation(data) {
    return this.http.put<any>(API_PATH.quotationAPI.createQuotation, data);
  }
  updateQuotationStatus(data) {
    return this.http.put<any>(API_PATH.quotationAPI.updateQuoteStatus, data);
  }
  getQuotationDetails(id) {
    return this.http.get<any>(API_PATH.quotationAPI.createQuotation + "/" + id);
  }
  getQuotationFilters(type) {
    let httpParams = new HttpParams().set(
      "businessUnitId",
      JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id
    );
    httpParams = type ? httpParams.set("status", type.toString()) : httpParams;
    httpParams = httpParams.set("isFiltersQuery", "true");
    return this.http.get<any>(API_PATH.quotationAPI.createQuotation, {
      params: httpParams,
    });
  }
  getQuotationList(
    type,
    page = 1,
    limit = 10,
    searchText?,
    sort?,
    sortType?,
    fromData?,
    toDate?,
    sellerList?,
    fromValue?,
    toValue?
  ) {
    let httpParams = new HttpParams().set(
      "businessUnitId",
      JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id
    );
    httpParams = type ? httpParams.set("status", type.toString()) : httpParams;
    httpParams = page ? httpParams.set("page", page.toString()) : httpParams;
    httpParams = limit ? httpParams.set("limit", limit.toString()) : httpParams;
    if (searchText) {
      httpParams = httpParams.set("searchText", searchText.toString());
      httpParams = httpParams.set(
        "searchField",
        "buyer.name,seller.name,customOrderNumber"
      );
    }
    httpParams = sort ? httpParams.set("sort", sort.toString()) : httpParams;
    httpParams = sortType
      ? httpParams.set("sortType", sortType.toString())
      : httpParams;
    httpParams = fromData
      ? httpParams.set("fromDate", this.slotService.stringDateFormat(fromData))
      : httpParams;
    httpParams = toDate
      ? httpParams.set("toDate", this.slotService.stringDateFormat(toDate))
      : httpParams;
    httpParams = sellerList
      ? httpParams.set("sellerList", sellerList.join(",").toString())
      : httpParams;
    httpParams =
      fromValue > -1
        ? httpParams.set("fromValue", fromValue.toString())
        : httpParams;
    httpParams = toValue
      ? httpParams.set("toValue", toValue.toString())
      : httpParams;
    return this.http.get<any>(API_PATH.quotationAPI.createQuotation, {
      params: httpParams,
    });
  }
}
